import type { Timestamp } from "@bufbuild/protobuf";
import type { UserBalanceWithFundSource } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import type { GetMyBalancesResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";

/**
 * 残高データから合計金額と最も近い有効期限を計算する関数
 * @param balance 残高データ
 * @returns 合計金額、最も近い有効期限のタイムスタンプ、有効期限のDate
 */
export const getBalanceInfo = (balance: GetMyBalancesResponse) => {
  const totalAmount = balance.balanceWithFundSources.reduce(
    (acc: number, balance: UserBalanceWithFundSource) =>
      acc + Number(balance.userBalance?.amount || 0),
    0,
  );

  // 残高が0より大きいもののみを対象にする
  const nonZeroBalances = balance.balanceWithFundSources.filter(
    (b) => (b.userBalance?.amount ?? 0n) > 0n,
  );

  const nearestExpireAt =
    nonZeroBalances.length > 0
      ? nonZeroBalances.reduce(
          (
            nearest: Timestamp | undefined,
            current: UserBalanceWithFundSource,
          ) => {
            if (
              !nearest ||
              (current.userBalance?.expireAt &&
                current.userBalance?.expireAt.seconds < nearest.seconds)
            ) {
              return current.userBalance?.expireAt;
            }
            return nearest;
          },
          nonZeroBalances[0].userBalance?.expireAt,
        )
      : null;

  const nearestExpireAtDate = nearestExpireAt
    ? new Date(Number(nearestExpireAt.seconds) * 1000)
    : null;

  return { totalAmount, nearestExpireAt, nearestExpireAtDate };
};
